import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { useGetProductQuery } from "../../features/api/productApi";
import { useGetExpenseQuery } from "../../features/api/expenseApi";
import { useGetAllModelQuery } from "../../features/api/modelApi";
import { formatDate } from "../../components/CommonDateFormat";

const ExpenseItem = () => {
  const productModels = useGetAllModelQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data?.filter((d) => d?.subcategory_id === 10);
  const [subItemList, setSubItemList] = useState("");

  const { data, isLoading } = useGetExpenseQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const expenses = data?.expense;

  const filtrItem = subItemList
    ? expenses?.filter((exp) => exp?.part === subItemList)
    : expenses;

  const products = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="px-12">
      <div className="flex justify-between items-center py-4">
        <h1 className="text-xl font-bold">Expense Item</h1>
      </div>
      <div className="flex flex-col gap-1 w-[300px]">
        <select
          onChange={(e) => setSubItemList(Number(e.target.value))}
          className="border h-8 pl-1 rounded"
        >
          <option value="">--Search Item--</option>
          {productModels?.map((proM) => (
            <option key={proM?.model_id} value={proM?.model_id}>
              {proM?.model_name}
            </option>
          ))}
        </select>
      </div>
      <div className="py-4">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : expenses?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no expense Items
          </p>
        ) : (
          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Expense no.</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Date</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Sub Item</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Particular</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Expense Month</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Amount</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold text-center">Remarks</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filtrItem
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => {
                    const proName = productModels?.find(
                      (pro) => pro?.model_id === row?.part
                    );
                    const itemName = products?.find(
                      (sub) => sub?.id == row?.item
                    );

                    return (
                      <TableRow key={row?.id}>
                        <TableCell>{row?.exp_no}</TableCell>
                        <TableCell>{formatDate(row?.exp_date)}</TableCell>
                        <TableCell>{itemName?.product_name}</TableCell>
                        <TableCell>{proName?.model_name}</TableCell>
                        <TableCell>
                          {row?.qty === 1
                            ? "January"
                            : row?.qty === 2
                            ? "February"
                            : row?.qty === 3
                            ? "March"
                            : row?.qty === 4
                            ? "April"
                            : row?.qty === 5
                            ? "May"
                            : row?.qty === 6
                            ? "June"
                            : row?.qty === 7
                            ? "July"
                            : row?.qty === 8
                            ? "August"
                            : row?.qty === 9
                            ? "September"
                            : row?.qty === 10
                            ? "October"
                            : row?.qty === 11
                            ? "November"
                            : "December"}
                        </TableCell>
                        <TableCell>{row?.exp_amt}</TableCell>
                        <TableCell>{row?.rmk}</TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[50, 100, 200]}
              component="div"
              count={expenses?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default ExpenseItem;
